<article class="watchlist-wrapper">
  <bau365-breadcrumb [breadcrumbElements]="breadcrumbElements"></bau365-breadcrumb>
  @if (itemCount$ | async; as itemCount) {
  <header class="watchlist-header">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 watchlist-controls">
          <h1 class="mat-headline-4" i18n="@@featureWatchlist-pageHeader">Merkliste</h1>
          @if (screen$ | async; as screen) {
          <bau365-watchlist-filter-button
            [screen]="screen$ | async"
            [markAsActive]="(itemCategory$ | async) !== ItemCategory.all"
            (filterButtonClicked)="onFilterButtonClicked(screen)">
          </bau365-watchlist-filter-button>
          }
        </div>
      </div>
    </div>
  </header>
  @if (loaded$ | async) {
  <section class="watchlist-results">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <div class="watchlist-results__header">
            <bau365-watchlist-result-count
              [watchlistItemsCount]="itemCount"
              [itemCategory]="itemCategory$ | async"></bau365-watchlist-result-count>
            @if (itemCount > 0) {
            <bau365-export-toggle-v2
              class="export-toggle"
              listType="watchlist"
              [emailSubject]="emailSubject"
              [emailBody]="emailBody"
              [showForward]="true"></bau365-export-toggle-v2>
            }
          </div>
          <bau365-watchlist-results
            [screen]="screen$ | async"
            [itemTypes]="itemTypes"
            [fairsConfig]="fairsConfig$ | async"
            [watchlistItems]="itemsOnPage$ | async"
            (deleteItem)="onDeleteItem($event)"
            (shareItem)="onShareItem($event)"
            (shareItemAction)="onShareItemAction($event)"></bau365-watchlist-results>
          <planone-paginator
            [pageIndex]="currentPage$ | async"
            [pageCount]="pageCount$ | async"
            (pageChanged)="onChangeWatchlistPage($event.pageIndex)"></planone-paginator>
        </div>
      </div>
    </div>
  </section>
  } @else {
  <div class="loading-animation">
    <planone-loading-animation></planone-loading-animation>
  </div>
  }
  <ng-template #loading>
    <div class="loading-animation">
      <planone-loading-animation></planone-loading-animation>
    </div>
  </ng-template>
  } @else {
  <section class="watchlist-results">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <bau365-empty-watchlist
            [fairId]="bauInsightsId$ | async"
            [fairsConfig]="fairsConfig$ | async"
            [displayDescription]="true"></bau365-empty-watchlist>
        </div>
      </div>
    </div>
  </section>
  }
</article>
<ng-template #filterDialogTitle>
  <div i18n="@@featureWatchlist-itemCategory">Kategorie</div>
</ng-template>
<ng-template #filterDialogContent>
  <bau365-watchlist-filter-dialog
    [itemCategories]="itemCategories$ | async"
    [itemCategory]="itemCategory$ | async"
    (itemCategoryChanged)="onItemCategoryChanged($event)"></bau365-watchlist-filter-dialog>
</ng-template>
<ng-template #filterDialogActions>
  <div class="filter-dialog-actions">
    <button
      mat-flat-button
      color="primary"
      i18n="@@featureWatchlist-filterDialog-showResults"
      (click)="onSubmitItemCategory()">
      Ergebnisse anzeigen
    </button>
    <button
      mat-flat-button
      color="secondary"
      i18n="@@featureWatchlist-filterDialog-clearFilters"
      (click)="onResetItemCategory()">
      Filter zurücksetzen
    </button>
  </div>
</ng-template>
